import React, { createContext, useEffect, useState } from 'react';

export const SelectedOfferContext = createContext();

export const SelectedOfferProvider = ({ children, initialSelectedOffer = null }) => {
  const [selectedOffer, setSelectedOffer] = useState(initialSelectedOffer);

  useEffect(() => {
    if (initialSelectedOffer) {
      setSelectedOffer(initialSelectedOffer);
    }
  }, [initialSelectedOffer]);

  return (
    <SelectedOfferContext.Provider value={{ selectedOffer, setSelectedOffer }}>
      {children}
    </SelectedOfferContext.Provider>
  );
};